import React from 'react'
import playbtn from '../../Assets/Images/play-btn.svg';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function VideoCard({video}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div className="video-box">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="video-container">

          <div className="video">
            <video style={{maxWidth: "100%", maxHeight: "100%" }} controls loop autoPlay>
              <source src= { video.source } type="video/mp4" />
            </video>
          </div>

          <Button className='close' onClick={handleClose} >Close</Button>
        </div>
      </Modal>
      <div onClick={handleOpen} className="thumbnail">
        <img src={video.image} alt="" />
        <img src={playbtn} className="play-btn-img" alt="" />
        <div className="type">{video.type}</div>
      </div>
      <div className="info">
        <div className="name">{video.title}</div>
        <div className="time">{video.time}</div>
      </div>
    </div>
  )
}
